import { I18NString } from "../helpers/Utils";

export const Errors: { [key: string]: I18NString } = {
	REQUIRED: {
		ru: "Поле не заполнено",
	},
	MAX_LENGTH: {
		ru: "Максимальное кол-во символов",
	},
	MIN_LENGTH: {
		ru: "Минимальное кол-во символов",
	},
	INVALID_FILE_FORMAT: {
		ru: "Неверный формат файла: *.",
	},
	MAX_FILE_SIZE: {
		ru: "Максимальный размер файла: ",
	},
	MIN_VALUE: {
		ru: "Меньше минимального числа ",
	},
	MAX_VALUE: {
		ru: "Больше максимального числа ",
	},
	MIN_SELECTED_ITEMS: {
		ru: "Должно быть выбрано минимум",
	},
	MAX_SELECTED_ITEMS: {
		ru: "Должно быть выбрано максимум",
	},
	NOT_LINK: {
		ru: "Неверный формат ссылки",
	},
	NOT_EMAIL: {
		ru: "Неверный формат электронной почты",
	},
	WRONG_PHONE: {
		ru: "Введён некорректный телефонный номер",
	},
	WRONG_TAG_SELECTED: {
		ru: "Выбран элемент не из списка",
	},
};

export const Captions: { [key: string]: I18NString } = {
	FILE: {
		ru: "Выбрать файл",
	},
	DELETE: {
		ru: "Удалить",
	},
	ADD: {
		ru: "Добавить",
	},
	SEND: {
		ru: "Отправить на валидацию",
	},
};

export const Strings: { [key: string]: I18NString } = {
	FILE_MAX_SIZE: {
		ru: "Максимальный размер файла",
	},
	CONFIRM_DELETE: {
		ru: "Вы увурены что хотитие удалить?",
	},
	EMPTY: {
		ru: "Нет записей",
	},
};
